const FollowUpIcon = ({ size = 56, className = "", isActive = false, ...props }) => {
  const backgroundColor = isActive ? "#68D7FF" : "#9EA6B2";
  const backgroundOpacity = isActive ? 0.2 : 0.3;
  const iconColor = isActive ? "#01BBFE" : "white";
  const gradientId = isActive ? "blueGradient" : "whiteGradient";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Background Circle */}
      <circle cx="28" cy="28" r="27" fill={backgroundColor} fillOpacity={backgroundOpacity} />
      <circle cx="28" cy="28" r="27" stroke={`url(#${gradientId})`} strokeWidth="2" />

      {/* Document Icon */}
      <path
        d="M34 38C34.5304 38 35.0391 37.7893 35.4142 37.4142C35.7893 37.0391 36 36.5304 36 36V24L30 18H22C21.4696 18 20.9609 18.2107 20.5858 18.5858C20.2107 18.9609 20 19.4696 20 20V36C20 36.5304 20.2107 37.0391 20.5858 37.4142C20.9609 37.7893 21.4696 38 22 38H34ZM29 20L34 25H29V20ZM23 24H26V26H23V24ZM23 28H33V30H23V28ZM23 32H33V34H23V32Z"
        fill={iconColor}
      />

      {/* Gradient Definitions */}
      <defs>
        <linearGradient id="whiteGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="blueGradient" x1="3.95" y1="4.4" x2="50.76" y2="54.45" gradientUnits="userSpaceOnUse">
          <stop stopColor="#68D7FF" />
          <stop offset="1" stopColor="#68D7FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FollowUpIcon;
